angular.module('unergie.main')
.directive('salesTunnelBPClosingV3', ($q, $state, MetaWatcher, ErrorCatcher, AlertManager, AuthService) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        checks: '=',
        validated: '=',
        validation: '=',
        shootDraftMessage: '=',
        draftServices: '=',
        draftState: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelBPClosingV3.html',
    link($scope) {
        $scope.form = {}

        // CHECKOUT
        $scope.shootDraftTemplate = {}
        $scope.shootDraftFields = {}
        $scope.shootDraftButtons = {}

        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

        $scope.readyToShoot = () => $scope.form.accept_cgv &&
            !$scope.checks.transformed && $scope.validated.all &&
            (!$scope.draft.subscription_fee || $scope.form.client_fee_aware)

        $scope.prepareShootDraft = function (vendorSignature) {
            $scope.shootDraftFields = {
                overdue: {
                    type: 'label',
                    label: '<i class="fa fa-spinner fa-spin fa-fw"></i>&nbsp;Vérification en cours...',
                },
            }
            $scope.shootDraftButtons = {}
            const update = {
                accept_contacts: $scope.form.accept_contacts,
                consent_curves: $scope.form.consent_data,
                consent_index: $scope.form.consent_data,
            }
            return $scope.draftServices.saveSelfReport($scope.draft.id_account, $scope.draft.draftElec.id)
            .then(() => {
                $scope.shootDraftFields = {}
                $scope.shootDraftButtons.signWithClient = {
                    label: `Signer avec le client&nbsp;<i class="fa fa-phone"></i>`,
                    buttonClass: 'btn-danger',
                    disabled() {
                        return $scope.draft.payment_type === 'CB'
                    },
                    execute() {
                        $scope.draftServices.signForClient(update)
                    },
                }
                $scope.shootDraftButtons.signSms = {
                    label: `Le laisser signer par SMS&nbsp;<i class="fa fa-mobile"></i>`,
                    execute() {
                        $scope.draftServices.shootDraft(update, 'SMS')
                    },
                }
                $scope.shootDraftButtons.signMail = {
                    label: `Le laisser signer par Mail&nbsp;<i class="fa fa-envelope-o"></i>`,
                    disabled() {
                        return $scope.draft.mail.includes('@client.plum.fr')
                    },
                    execute() {
                        $scope.draftServices.shootDraft(update, 'EMAIL', $scope.shootDraftTemplate.email)
                    },
                }
            })
            .catch((error) => {
                ErrorCatcher(error)
                $scope.shootDraftFields = {}
            })
        }

        const initForm = (draft) => {
            _.assign($scope.form, {
                consent_data: draft.consent_curves && draft.consent_index,
                accept_contacts: draft.accept_contacts,
            })
        }

        $scope.$watch('draft', initForm)

        const activate = function () {
            initForm($scope.draft)
        }

        activate()
    },
}))
